import React from 'react';
import { Icons, Grid } from '@cherre-frontend/ui';

const IconsPage = () => {
  const icons = Object.values(Icons).map((IconComponent) => {
    const name = (IconComponent as any).type?.render?.displayName;

    return (
      <div key={name}>
        <p>{name}</p>
        <IconComponent />
      </div>
    );
  });

  return (
    <>
      <h1>@cherre-frontend/ui Icons</h1>
      <Grid padding={1} display='flex' flexWrap='wrap' gap={3} color='black'>
        {icons}
      </Grid>
    </>
  );
};

export default IconsPage;
